class Form {
  constructor() {
    if(document.querySelector('form') != null && document.querySelector('form') != undefined) {
      this.setMasks();
    }
  }

  setMasks() {
    var tel = document.querySelector('.tel');
    if(tel) {
      var maskTel = IMask(tel, {
        mask: '(00) 00000-0000'
      });
    }

    var cpf = document.querySelector('.cpf');
    if(cpf) {
      var maskCpf = IMask(cpf, {
        mask: '000.000.000-00'
      });
    }
    
    var birth = document.querySelector('.birth');
    if(birth) {
      var maskBirth = IMask(birth, {
        mask: '00/00/0000'
      });
    }
    
    var cep = document.querySelector('.cep');
    if(cep) {
      var maskCep = IMask(cep, {
        mask: '00000-000'
      });
    }
    
    var ccnumber = document.querySelector('.cc-number');
    if(ccnumber) {
      var maskccnumber = IMask(ccnumber, {
        mask: '0000.0000.0000.0000'
      });
    }
    
    var ccdate = document.querySelector('.cc-date');
    if(ccdate) {
      var maskccdate = IMask(ccdate, {
        mask: '00/0000'
      });
    }
    
    var cccvv = document.querySelector('.cc-cvv');
    if(cccvv) {
      var maskcccvv = IMask(cccvv, {
        mask: '000'
      });
    }
  }
}

const form = new Form();
